<template>
    <div class="page-content header-clear-medium">

		<div v-if="loading">		
			<div class="card card-style">
				<div class="content">
					<!-- <PuSkeleton :height="400" /> -->
					<vue-skeleton-loader
						:height="250"
						animation="fade" 
						class="w-100 rounded-s"
					/>
				</div>
			</div>

			<div class="card card-style">
				<div class="content">
					<div class="row mb-2">
						<div class="col-4">
							<vue-skeleton-loader
								:height="125"
								animation="fade" 
								class="w-100 rounded-s"
							/>
						</div>
						<div class="col-4">
							<vue-skeleton-loader
								:height="125"
								animation="fade" 
								class="w-100 rounded-s"
							/>
						</div>
						<div class="col-4">
							<vue-skeleton-loader
								:height="125"
								animation="fade" 
								class="w-100 rounded-s"
							/>
						</div>
					</div>
				</div>
			</div>
			
			<!-- <content-skeleton count="5"></content-skeleton> -->
		</div>
		<div v-else class="card card-style">
			<div class="card-body px-0 py-0">
				<!-- <h6 class="font-700 opacity-60 content mb-2">Single Boxed Slider - with Arrows and Dots</h6> -->
				<div class="splide splide-custom single-slider slider-dots-under slider-boxed" id="single-slider-1">
					<div class="splide__track">
						<div class="splide__list">

							<div class="splide__slide" v-for="item in homepage_post" :key="item.id">
								<router-link :to="{ name: 'news' }">
								<!-- <div data-card-height="400" class="card bg-11 rounded-m shadow-l" :style="{ 'background-image': 'url('+item.image+')', 'object-fit': 'fill' }"></div> -->
								<div data-card-height="400" class="card bg-11 rounded-m shadow-l" :style="{ 'background-image': 'url('+item._embedded['wp:featuredmedia'][0]['source_url']+')', 'object-fit': 'fill' }">
									<div class="card-bottom text-center m-3">
										<h2 class="color-white text-uppercase font-900 mb-0" v-html="item.title.rendered"></h2>
										<p class="under-heading color-white opacity-60 mb-0" v-html="item.excerpt.rendered.substring(0,50).replace(/(<p[^>]+?>|<p>|<\/p>)/img, '')"></p>
										<!-- <h2 class="color-white text-uppercase font-900 mb-3" v-html="item.title.rendered"></h2>
										<p class="under-heading color-white opacity-60 mb-0" v-html="item.excerpt.rendered.replace(/(<p[^>]+?>|<p>|<\/p>)/img, '').substring(0, 100)"></p> -->
									</div>
									<div class="card-overlay rounded-m bg-gradient-fade opacity-90"></div>
								</div>
								</router-link>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="!loading" class="row mb-2">
			<!-- <div class="col-4" style="padding-right:0;padding-left:0;"> -->
			<div class="col-4">
				<router-link :to="{ name: 'news' }">
					<div class="card card-style bg-blue-light" style="overflow: initial;margin-right:5px;">
						<div class="card-body text-center badge-container">
							<!-- <i class="bi bi-bootstrap-fill color-magenta-dark font-50 d-block pb-2"></i> -->
							<em v-if="postReadAllLocal < total_post" class="badge bage-number bg-yellow-dark">{{ total_post - postReadAllLocal }}</em>
							<i class="bi bi-newspaper font-50 d-block pb-2"></i>
							<h5 class="pt-2 font-200 color-white">Berita</h5>
						</div>
					</div>
				</router-link>
			</div>
			<!-- <div class="col-4" style="padding-right:0;padding-left:0;"> -->
			<div class="col-4">
				<router-link :to="{ name: 'announcement' }">
					<div class="card card-style bg-pink-light" style="overflow: initial;margin-right:5px;margin-left:0;">
						<div class="card-body text-center badge-container">
							<em v-if="announcementsReadLocal.length < announcements_total" class="badge bage-number bg-yellow-dark">{{ announcements_total - announcementsReadLocal.length }}</em>
							<i class="bi bi-megaphone-fill font-50 d-block pb-2"></i>
							<h6 class="pt-2 font-200 color-white">Pengumuman</h6>
						</div>
					</div>
				</router-link>
			</div>
			<!-- <div class="col-4" style="padding-right:0;padding-left:0;"> -->
			<div class="col-4">
				<router-link :to="{ name: 'event' }">
					<div class="card card-style bg-green-light" style="overflow: initial;margin-left:0;">
						<div class="card-body text-center badge-container">
							<em v-if="eventsReadLocal.length < events_total" class="badge bage-number bg-yellow-dark">{{ events_total - eventsReadLocal.length }}</em>
							<i class="bi bi-calendar4-week font-50 d-block pb-2"></i>
							<h5 class="pt-2 font-200 color-white">Event</h5>
						</div>
					</div>
				</router-link>
			</div>

			<div class="col-4" v-if="settingMobileData.includes('vue_kepsek_tamu')">
				<router-link :to="{ name: 'school.guest' }">
					<div class="card card-style bg-magenta-dark" style="overflow: initial;margin-right:5px;">
						<div class="card-body text-center badge-container">
							<em v-if="bukuTamuReadLocal.length < buku_tamu_today.length" class="badge bage-number bg-yellow-dark">{{ buku_tamu_today.length - bukuTamuReadLocal.length }}</em>
							<i class="bi bi-people-fill font-50 d-block pb-2"></i>
							<h5 class="pt-2 font-200 color-white">Tamu</h5>
						</div>
					</div>
				</router-link>
			</div>

			<div class="col-4" v-if="settingMobileData.includes('vue_kepsek_surat')">
				<router-link :to="{ name: 'envelope.index' }">
					<div class="card card-style bg-yellow-dark" style="overflow: initial;margin-right:5px;margin-left:0;">
						<div class="card-body text-center badge-container">
							<em v-if="total_unread > 0" class="badge bage-number bg-yellow-dark">{{ total_unread }}</em>
							<i class="bi bi-envelope font-50 d-block pb-2"></i>
							<h5 class="pt-2 font-200 color-white">Surat</h5>
						</div>
					</div>
				</router-link>
			</div>

			<div class="col-4" v-if="settingMobileData.includes('vue_kepsek_presensiguru')">
				<router-link :to="{ name: 'presence.teacher.index' }">
					<div class="card card-style bg-facebook" style="overflow: initial;margin-left:0;">
						<div class="card-body text-center badge-container">
							<!-- <em v-if="total_unread > 0" class="badge bage-number bg-yellow-dark">{{ total_unread }}</em> -->
							<i class="bi bi-person-check font-50 d-block pb-2"></i>
							<h5 class="pt-2 font-200 color-white font-14">Presensi Guru</h5>
						</div>
					</div>
				</router-link>
			</div>
			
			<div class="col-4" v-for="menu in menuDigitalSchool" :key="menu.id">
				<a :href="menu.url" target="__blank">
					<div class="card card-style bg-white" style="overflow: initial;margin-left:0;">
						<div class="card-body text-center badge-container">
							<img :src="menu.url_icon" class="img-thumbnail" width="50px" alt="">
							<h5 class="pt-2 font-200 color-primary font-14">{{ menu.name }}</h5>
						</div>
					</div>
				</a>
			</div>
		</div>

		<h2 class="text-center mb-3">MONITORING LAYANAN<br>DIGITIAL-SCHOOL.ID</h2>

		<div v-if="loading">		
			<content-skeleton count="5"></content-skeleton>
		</div>
		<div v-else>
			<div class="card card-style">
				<div class="content">
					<h3 class="mb-3">Presensi Terkendali</h3>

					<div class="row mb-3">
						<div class="col-lg-10">
							<div class="form-custom form-label form-border form-icon mb-2">
								<i class="bi bi-calendar font-12"></i>
								<input type="date" class="form-control rounded-xs" id="c5" v-model="presenceDate">
							</div>
						</div>
						<div class="col-lg-2">
							<button class="btn w-100 btn-sm bg-green-light" @click="searchPresence()">Cari</button>
						</div>
					</div>

					<p class="mb-2" v-if="!presenceLoading"><strong>{{ presences["total_classroom_presence"] }}</strong> dari <strong>{{ presences["total_classroom"] }}</strong> Kelas Telah Dilakukan Presensi</p>
					<p class="mb-2" v-else><strong>Loading...</strong></p>

					<div class="d-flex flex-column">
						<h5>Detail :</h5>
						<div v-if="!presenceLoading">
							<div class="d-flex justify-content-between">
								<p class="mb-1 fs-6">Siswa Hadir</p>
								<p class="mb-1 fs-6"><strong>{{ presences['H'] }} Siswa</strong></p>
							</div>
							<div class="d-flex justify-content-between">
								<p class="mb-1 text-sm fs-6">Siswa Sakit</p>
								<p class="mb-1 fs-6"><strong>{{ presences['S'] }} Siswa</strong></p>
							</div>
							<div class="d-flex justify-content-between">
								<p class="mb-1 fs-6">Siswa Izin</p>
								<p class="mb-1 fs-6"><strong>{{ presences['I'] }} Siswa</strong></p>
							</div>
							<div class="d-flex justify-content-between">
								<p class="mb-1 fs-6">Siswa Dispensasi</p>
								<p class="mb-1 fs-6"><strong>{{ presences['D'] }} Siswa</strong></p>
							</div>
							<div class="d-flex justify-content-between">
								<p class="mb-1 fs-6">Siswa Alfa</p>
								<p class="mb-1 fs-6"><strong>{{ presences['A'] }} Siswa</strong></p>
							</div>
							<div class="d-flex justify-content-between">
								<p class="color-red-dark fs-6"><strong>Belum Ada Keterangan</strong></p>
								<p class="color-red-dark fs-6"><strong>{{ presences['others'] }} Siswa</strong></p>
							</div>

							<router-link :to="{ name: 'presence', query:{date: presenceDate} }" class="btn-full btn gradient-blue">Detail Informasi</router-link>
						</div>
						<div v-else>
							<vue-skeleton-loader
								v-for="i in 5"
								:key="i"
								:height="20"
								animation="fade" 
								class="w-100 rounded-s mt-2"
							/>

							<vue-skeleton-loader
								:height="50"
								animation="fade" 
								class="w-100 rounded-s mt-3"
							/>
						</div>
					</div>
				</div>
			</div>

			<div class="card card-style">
				<div class="content">
					<h3 class="mb-3">Tata Tertib Siswa</h3>

					<div class="row mb-3">
						<div class="col-lg-10">
							<ReportFilter 
								:type-filter.sync="tatibTypeFilter" 
								:daily-time.sync="tatibDailyTime" 
								:monthly-time.sync="tatibMonthlyTime" 
								:range-date-from.sync="tatibRangeDateFrom" 
								:range-date-to.sync="tatibRangeDateTo" 
								@set-type-filter="setDataFilter()"
							/>
						</div>
						<div class="col-lg-2">
							<button class="btn w-100 btn-sm bg-green-light" @click="searchTatib()">Cari</button>
						</div>
					</div>

					<p class="mb-2" v-if="!tatibLoading"><strong>{{ tatibs_all.length }} Jenis Pelanggaran</strong> Tata Tertib</p>
					<p class="mb-2" v-else><strong>Loading...</strong></p>

					<div class="d-flex flex-column">
						<h5>Detail :</h5>
						<div v-if="!tatibLoading">
							<div v-for="(item, index) in tatibs_all" :key="index" class="d-flex justify-content-between">
								<p class="mb-1 fs-6">{{ item.name }}</p>
								<p class="mb-1 fs-6"><strong>{{ item.data }} Siswa</strong></p>
								
							</div>

							<router-link :to="{ name: 'decency', query: {type: tatibTypeFilter, daily: tatibDailyTime, monthly: tatibMonthlyTime, date_from: tatibRangeDateFrom, date_to:tatibRangeDateTo } }" class="btn-full btn gradient-blue">Detail Informasi</router-link>
						</div>
						<div v-else>
							<vue-skeleton-loader
								v-for="i in 5"
								:key="i"
								:height="20"
								animation="fade" 
								class="w-100 rounded-s mt-2"
							/>

							<vue-skeleton-loader
								:height="50"
								animation="fade" 
								class="w-100 rounded-s mt-3"
							/>
						</div>
					</div>
				</div>
			</div>

			<!-- <div class="card card-style">
				<div class="content">
					<h3 class="mb-3">Pembayaran SPP</h3>

					<ReportFilter 
						:type-filter="paymentTypeFilter" 
						:daily-time="paymentDailyTime" 
						@get-data-daily="getDataPaymentDaily()"
						:monthly-time="paymentMonthlyTime" 
						@get-data-monthly="getDataPaymentMonthly()"
					/>

					<p class="mb-2"><strong>34 Pembayaran Masuk</strong></p>

					<div class="d-flex flex-column">
						<h5>Detail :</h5>
						<div class="d-flex justify-content-between">
							<p class="mb-1 fs-6">SPP</p>
							<p class="mb-1 fs-6"><strong>130 Siswa</strong></p>
						</div>
						<div class="d-flex justify-content-between">
							<p class="mb-1 fs-6">Uang Gedung</p>
							<p class="mb-1 fs-6"><strong>2 Siswa</strong></p>
						</div>
						<div class="d-flex justify-content-between">
							<p class="fs-6">Daftar Ulang</p>
							<p class="fs-6"><strong>420 Siswa</strong></p>
						</div>
						<a href="#" class="btn-full btn gradient-blue">Detail Informasi</a>
					</div>
				</div>
			</div> -->
		</div>
        
    </div>
</template>

<script>
import { 
	mapMutations, 
	mapActions, mapState 
} from 'vuex'
import ReportFilter from '../components/form/ReportFilter.vue'
import ContentSkeleton from "../components/skeleton/ContentSkeleton.vue";
import moment from 'moment'

export default {
	name: 'Home',
	components: {
	ReportFilter, 
	ContentSkeleton
	},
	data() {
		return {
			presenceLoading: true,
			tatibLoading: true,
			presenceDate: moment().format('YYYY-MM-DD'),
			tatibTypeFilter: 'monthly',
			tatibMonthlyTime: moment().format('MM'),
			tatibDailyTime: moment().format('YYYY-MM-DD'),
			tatibRangeDateFrom: moment().format('YYYY-MM-DD'),
			tatibRangeDateTo: moment().format('YYYY-MM-DD'),
			paymentTypeFilter: 'monthly',
			paymentMonthlyTime: moment().format('MM'),
			paymentDailyTime: moment().format('YYYY-MM-DD'),
		}
	},
	async created() {
		this.SET_LOADING()
		await this.getHomepagePost()
		await this.getAnnouncementsCount()
		await this.getEventsCount()
		await this.searchPresence()
		await this.searchTatib()
		await this.getBukuTamuToday()
		await this.getSuratTotalUnread()
		await this.getAllSettingMobile();
		await this.getAllMenuDigitalSchool();
		this.CLEAR_LOADING()
	},
	mounted() {
		this.$nextTick(function () {
			document.refreshSlider()
		})
	},
	updated() {
		this.$nextTick(function () {
			document.refreshSlider()
		})
	},
    methods: {
			...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
			...mapActions('postWp', ['getHomepagePost']),
			...mapActions('announcementWp', ['getAnnouncementsCount']),
			...mapActions('eventWp', ['getEventsCount']),
			...mapActions('presence', ['getPresences']),
			...mapActions('tatib', ['getTatibs', 'getTatibsAll']),
			...mapActions('bukuTamu', ['getBukuTamuToday']),
			...mapActions('envelope', ['getSuratTotalUnread']),
			...mapActions('settingMobile', ['getAllSettingMobile']),
			...mapActions('menuDigitalSchool', ['getAllMenuDigitalSchool']),
			async searchTatib() {
				this.tatibLoading = true;
				switch (this.tatibTypeFilter) {
					case 'monthly':
						await this.getDataTatibMonthly()
						break;
					case 'daily':
						await this.getDataTatibDaily()
						break;
					case 'all':
						await this.getDataTatibAll()
						break;
					case 'range':
						await this.getDataTatibRange()
						break;
					default:
						break;
				}
				this.tatibLoading = false;
			},
			async searchPresence() {
				this.presenceLoading = true;
				await this.getPresences(this.presenceDate)
				this.presenceLoading = false;
			},
			setDataFilter(value) {
				this.tatibTypeFilter = value;
			},
			async getDataTatibDaily() {
				await this.getTatibsAll({type: this.tatibTypeFilter, time: this.tatibDailyTime})
			},
			async getDataTatibMonthly() {
				// console.log(this.tatibMonthlyTime);
				await this.getTatibsAll({type: this.tatibTypeFilter, time: this.tatibMonthlyTime})
			},
			async getDataTatibRange() {
				await this.getTatibsAll({type: this.tatibTypeFilter, date_from: this.tatibRangeDateFrom, date_to: this.tatibRangeDateTo})
			},
			async getDataTatibAll() {
				await this.getTatibsAll({type: this.tatibTypeFilter})
			},
			getDataPaymentDaily() {
				alert('Mohon Maaf Fitur dalam Pengembangan Saat ini')
			},
			getDataPaymentMonthly() {
				alert('Mohon Maaf Fitur dalam Pengembangan Saat ini')
			},
    },
    computed: {
			...mapState({
				loading: state => state.loading
			}),
			...mapState('postWp', {
				homepage_post: state => state.homepage_post,
				total_post: state => state.total_post,
			}),
			...mapState('announcementWp', {
				announcements_total: state => state.announcements_total,
			}),
			...mapState('eventWp', {
				events_total: state => state.events_total,
			}),
			...mapState('presence', {
				presences: state => state.presences,
			}),
			...mapState('tatib', {
				tatibs_all: state => state.tatibs_all,
			}),
			...mapState('bukuTamu', {
				buku_tamu_today: state => state.buku_tamu_today,
			}),
			...mapState('notificationLocal', {
				postsReadLocal: state => state.postsReadLocal,
				postReadAllLocal: state => state.postReadAllLocal,
				announcementsReadLocal: state => state.announcementsReadLocal,
				eventsReadLocal: state => state.eventsReadLocal,
				bukuTamuReadLocal: state => state.bukuTamuReadLocal,
			}),
			...mapState('envelope', {
				total_unread: state => state.total_unread,
			}),
			...mapState('settingMobile', {
				settingMobileData: state => state.data.filter(item => item.value == 1).map(item => item.key),
			}),
			...mapState('menuDigitalSchool', {
				menuDigitalSchool: state => state.data,
			}),
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }

.badge-container .bage-number{
    height: 30px;
    min-width: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    border-radius: 15px;
    text-align: center;
    padding: 0px;
    position: absolute;
    margin-top: 0px;
    transform: translateX(4px);
    z-index: 3;
    top: -5px;
    right: -5px;
}
</style>
